<template>
  <div>
    <table class="ui striped definition unstackable fixed table" v-if="selectedActionPlanIdList.length !== 0">
      <thead class="full-width">
      <tr>
        <th class="center aligned one wide"></th>
        <th class="three wide">Action Short Name
          <i class="blue question large circle icon backoffice-glossary"
             data-content="Internal name only visible to your team"></i>
        </th>
        <th>Action Content</th>
        <th class="two wide center aligned">Tracking?
          <i class="blue question large circle icon backoffice-glossary"
             data-content="Whether the patient is required to track this action"></i>
        </th>
        <th class="two wide center aligned">Start Day
          <i class="blue question large circle icon backoffice-glossary"
             data-content="Relative day when the patient will see this action plan"></i>
        </th>
        <th class="two wide center aligned">End Day
          <i class="blue question large circle icon backoffice-glossary"
             data-content="Relative day when the patient stop seeing this action plan"></i>
        </th>
        <th class="center aligned one wide"></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="action in prevSelectedActionContent"
          :class="{disabled: action.data.deletedStatus}">
        <td class="center aligned">
          <div v-if="action.data.deletedStatus === false">
            <i class="lock icon" style="margin-right:0;"></i>
          </div>
        </td>
        <td>
          {{ action.data.shortName }}
        </td>
        <td>
          Action: <strong>{{ action.data.title }}</strong><br>
          <span v-html="action.data.body"></span>
          <br>
          Reminder: <strong>{{ action.data.options.reminder.title }}</strong><br>
          <span v-html="action.data.options.reminder.body"></span>
        </td>
        <td class="center aligned">
          <i v-if="action.data.options.userTracking.status === true" class="green checkmark icon"></i>
          <i v-if="action.data.options.userTracking.status === false" class="red close icon"></i>
        </td>
        <td class="center aligned">
          {{ action.data.options.startDay }}
        </td>
        <td class="center aligned">
          {{ action.data.options.endDay }}
        </td>
        <td class="center aligned">
          <div class="ui circular icon button" style="margin-right:0;"
               v-if="action.data.deletedStatus === false"
               @click="showHideConfirmation(action)">
            <i class="low vision icon"></i>
          </div>
          <div v-if="action.data.deletedStatus === true">
            <div class="ui tiny label">hidden</div>
          </div>
        </td>
      </tr>
      <tr v-for="action in mergedNewOnlyPatientActionPlan">
        <td class="center aligned">
          <div class="ui circular icon button" style="margin-right:0;"
               @click="showEditModal(action)">
            <i class="pencil alternate icon"></i>
          </div>
        </td>
        <td>
          {{ action.data.shortName }}
        </td>
        <td>
          <i class="child icon"></i>Action
          <br>
          <strong>{{ action.data.title }}</strong><br>
          <span v-html="action.data.body"></span>
          <br>
          <i class="bell icon"></i>Reminder
          <br>
          <strong>{{ action.data.options.reminder.title }}</strong><br>
          <p v-html="action.data.options.reminder.body"></p>
        </td>
        <td class="center aligned">
          <i v-if="action.data.options.userTracking.status === true" class="green checkmark icon"></i>
          <i v-if="action.data.options.userTracking.status === false" class="red close icon"></i>
        </td>
        <td class="center aligned">
          {{ action.data.options.startDay }}
        </td>
        <td class="center aligned">
          {{ action.data.options.endDay }}
        </td>
        <td class="center aligned">
          <div class="ui circular basic icon button"
               style="margin-right:0;"
               @click="deleteOneAction(action)">
            <i class="trash icon"></i>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
    <patient-action-plan-edit-modal
      :selectedAction="selectedAction"
      ref="actionModal"
      @updateUserActions="updateUserActions">
    </patient-action-plan-edit-modal>
    <patient-action-hide-modal
      :patientId="patientId"
      :selectedAction="selectedAction"
      ref="actionDeactivateModal">
    </patient-action-hide-modal>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import PatientActionPlanEditModal from './PatientActionPlanEditModal'
  import PatientActionHideModal from './PatientActionHideModal'
  import dataStructure from '../../validation/dataStructure'
	export default {
	  props: {
      selectedActionPlanIdList: {
        type: Array,
        required: true
      },
      prevSelectedActionContent: {
        type: Array,
        required: false,
        default: function(){
          return [];
        }
      },
      patientId: {
        type: Number,
        required: true
      }
    },
    components: {
      PatientActionPlanEditModal,
      PatientActionHideModal
    },
		data() {
			return {
			  selectedAction: JSON.parse(JSON.stringify(dataStructure.actionStructure)),
        mergedNewOnlyPatientActionPlan: []
      }
		},
		computed: {
      ...mapState(['coachingActionsAll']),

    },
		methods: {
      showHideConfirmation(action){
        this.selectedAction = action;
        $(this.$refs.actionDeactivateModal.modalId).modal({ closable: false}).modal('show');
      },
      updateUserActions: function(payload){
        let targetActionPlanIndex = this.mergedNewOnlyPatientActionPlan.findIndex((element) =>
          element.id === payload.id
        );
        //this finds and replace the target payload
        this.mergedNewOnlyPatientActionPlan.splice(targetActionPlanIndex, 1, payload);
      },
	    showEditModal(action){
        this.selectedAction = action;
        $(this.$refs.actionModal.modalId).modal({ closable: false, autofocus: false }).modal('show');
      },
      //Note: Watch of selectedActionPlanIdList handles addition only. Deletion is handled by deleteOneAction
      deleteOneAction(action){

        let targetActionIndex = this.mergedNewOnlyPatientActionPlan.map(
          (element) => { return element.id}).indexOf(action.id);
        this.mergedNewOnlyPatientActionPlan.splice(targetActionIndex, 1);

        let payload = this.selectedActionPlanIdList;

        if (payload.indexOf(action.id) > -1){
          payload.splice(payload.indexOf(action.id), 1);
          this.$emit('updateActions', payload);
        }
        else {
          Rollbar.error("deleteOneAction try to remove action id that does not belong");
          this.$emit('updateActions', payload);
        }
      }
    },
    watch: {
	    //Note: This watch handles addition only. deletion is handled by deleteOneAction()
      selectedActionPlanIdList: function(newVal, oldVal){
        window.requestAnimationFrame(()=> {
          $('.backoffice-glossary').popup();
        });
        let additionList = newVal.filter((item) => {
          return oldVal.indexOf(item) === -1
        });

        //For each in additionList, do a mergeID and then push to the local data
        additionList.forEach((actionId)=> {
          let lookupPlan = this.coachingActionsAll.find((element) => {
            return element.id === actionId;
          });

          if (typeof(lookupPlan) !== 'undefined' && lookupPlan.data.deletedStatus === false){
            this.mergedNewOnlyPatientActionPlan.push(lookupPlan);
          }
        });

      },
      mergedNewOnlyPatientActionPlan: function(newVal){
        let payload = newVal;
        this.$emit('updateNewOnlyActions', payload);
      }
    },
		mounted() {

      //Note: This is to make sure when you alt-tab out, the selected actions/lessons don't disappear
	    if (this.selectedActionPlanIdList.length > this.prevSelectedActionContent.length) {
	      this.selectedActionPlanIdList.forEach((id)=>{
	        if (this.prevSelectedActionContent.filter((element) => { return element.id === id}).length === 0){
            let k = this.coachingActionsAll.find((element) => { return element.id === id});
            this.mergedNewOnlyPatientActionPlan.push(k);
          }
        })
      }
		}
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/patients/PatientActionPlanTable.vue